// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import {Link} from 'react-router-dom';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import Checkbox from 'material-ui/Checkbox'
import Avatar               from 'material-ui/Avatar';
var Spinner = require('react-spinkit');
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import EditLead from '../editLead';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import ScheduleDemo from '../scheduleDemo';
import EditProfile from '../editProfile';
import ChildProfile from '../childProfile';
import CircularProgress from 'material-ui/CircularProgress';


const customStyles = {
 

  content : {
    top                   : '2%',
    left                  : '2%',
    right                 : '2%',
    bottom                : '2%',
   
    
  },
    overlay: {
     background: "grey",
     overflow: 'hidden',
     position: 'fixed',
     zIndex   : '100000'
    
   }

}; 




class CustomerDetails extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      dialog_open: false,
      dialog_unpause_open:false,
      active_tab: (props.match.params.page == 'booking') ? 2 : 1,
      pause_date:'',
      rejoining_date:'',
      pause_start:'',
      subscription_id:'',
      support_tickets:[],
      session_feedbacks:[],
      customer_leads:[],
      customer_bookings:[],
      customer_subscriptions:[],
      result:[],
      activities:[],
      popUpVisible:false,
      name:'',
      pause_types: {},
      pause_type: 0,
      current_homebatches:[],
      deleted_homebatches:[],
      community_member_status:[],
      file:null,
      view_photo:false,
      credit_balance: 0,
      edit_size: false,
      edit_kit: false,
      edit_percent: false,
      jersey_size: '',
      no_of_kits: '',
      scholar_percent: '',
      addVerification:false,
      editVerification:false,
      venue_list:[],
      member_types:[],
      verification_details:{
        selected_venue_id:'',
        member_type:'',
        card_number:'',
      },
      card_image:null,
      end_date:''

    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitUnpause = this.handleSubmitUnpause.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onClicked = this.onClicked.bind(this);
    this.verifyStudent = this.verifyStudent.bind(this);
    this.setStudentVerified = this.setStudentVerified.bind(this);
    this.fileHandler = this.fileHandler.bind(this);
    this.postStudentInfo = this.postStudentInfo.bind(this);
    this.validateStudentInfo = this.validateStudentInfo.bind(this);
    this.handleexpdate = this.handleexpdate.bind(this);
    this.imageChange = this.imageChange.bind(this)
    this.addverification = this.addverification.bind(this)
    
    
    
  }

  handleTabClick(tabIndex){
        if(tabIndex==1 ){
          this.customerLeads();
        }else if(tabIndex==2 ){
          this.customerBookings();
        }else if(tabIndex==3  ){
          this.customerSubscriptions();
          // this.currentHomebatches();

        }
        else if(tabIndex==4 ){
          this.customerSupportTickets();
        }
        else if(tabIndex==5 ){
          this.customerSessionFeedbacks();
        }
        else if(tabIndex==6 ){
          this.customerAttendence();
        }
        else if(tabIndex==7 ){
          this.customerActivity();
        }





        this.setState({
            active_tab: tabIndex,
        });
    }

  

 

  closeModal() {
    this.setState({popUpVisible: false});
  }

  onClicked(e){
    console.log('name')
    console.log(e)
    this.setState({name:e, popUpVisible:true});
  }

  handleOpen = (id) => {
    this.setState({dialog_open: true});
    this.setState({subscription_id:id})
  };

  handleClose = () => {
    this.setState({dialog_open: false,dialog_unpause_open:false,view_photo:false});
  };


  componentDidMount() {
     this.customerFulldetails();
     this.customerLeads();
     this.getPauseTypes();
      console.log('didMount leads length')
      console.log(this.state.customer_leads.length)
    //this.customerSessionFeedbacks(); 
  }


  componentWillMount(){
  }

  customerFulldetails(){
    console.log('we are here in customerFulldetails')

    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data,credit_balance:data.credit_balance,community_member_status:data.community_member_status}))
       .catch(error => error);
  }
  customerLeads(id){
    var selected_id = this.state.id;
    if(id){
      selected_id = id
    }
    const url = `${getLocationOrigin()}/customer_list/get_customer_leads/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_leads:data.customer_leads.leads}))
       .catch(error => error);
  }


  customerBookings(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_bookings/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_bookings:data.customer_bookings.bookings}))
       .catch(error => error);

  }

  customerSubscriptions(){
    const url = `${getLocationOrigin()}/customer_list/get_customer_subscriptions/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({customer_subscriptions:data.customer_subscriptions[0].subscriptions}))
       .catch(error => error);
 
  }

  getPauseTypes(){
    const url = `${getLocationOrigin()}/subscriptionpause/get_pause_types/`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({pause_types:data.pause_types}))
       .catch(error => error);
  }







  switchProfile(id, props){
    console.log('in switch profile')
    this.setState({dialog_open: false});
    
    const url = `${getLocationOrigin()}/customer_list/get_customer_info/?customer_id=${id}`;
    const options = {...defaultOptions};

    
    
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ profile_list: data.profile_list, profile_data: data.profile_data,  id: id},()=>{this.handleTabClick(this.state.active_tab)},()=>{$(".tabs").load(window.location.href+" .tabs");}))
       .catch(error => error);
  }
  customerSupportTickets(){
    const url = `${getLocationOrigin()}/customer_list/get_support_tickets/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ support_tickets: data.support_tickets}))
       .catch(error => error);

 
  }

  customerSessionFeedbacks(){
    console.log('this is customerSessionFeedbacks ')
    const url = `${getLocationOrigin()}/customer_list/get_session_feedbacks/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ session_feedbacks: data.session_feedbacks}))
       .catch(error => error);
       
 
  }
  customerAttendence(){
    console.log('this is customerAttendence ')
    const url = `${getLocationOrigin()}/customer_list/get_player_attendance/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ result: data.result}))
       .catch(error => error);
      console.log('results')
      console.log(data.result)
 
  }

  currentHomebatches(){
    console.log('this is currentHomebatches ')
    const url = `${getLocationOrigin()}/customer_list/homebatches_details/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ current_homebatches: data.current_homebatches,deleted_homebatches:data.deleted_homebatches}))
       .catch(error => error);
      console.log('results....')
      console.log(data.result)
 
  }

  customerActivity(){
    console.log('this is customerActivity ')
    const url = `${getLocationOrigin()}/customer_list/get_customer_activities/?customer_id=${this.state.id}`;
    const options = {...defaultOptions};

    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ activities: data.activities}))
       .catch(error => error);
      console.log('activities')
      console.log(data.activities)
  }

  handleChange(event) {
    var name = event.target.name;
    if (name == 'pause_type'){
      this.setState({pause_type: event.target.value})
    }
    else if(name == 'pause_start'){
      this.setState({pause_start: event.target.value})
    }
    else if(name == 'rejoining_date'){
      this.setState({rejoining_date: event.target.value})
    }
    else{
      this.setState({pause_date: event.target.value})
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    if(this.state.pause_date){
      this.postPauseSubscription(this.state.pause_date, this.state.pause_start, this.state.pause_type, this.state.subscription_id, this.props);
      
    }
    else{
      alert("Please Enter Date")
    }
    this.currentHomebatches()
    this.customerSubscriptions()
  }

  handleSubmitUnpause(event) {
    console.log('handlesubmit....')
    console.log(event.target.name)
    event.preventDefault();
    if(this.state.rejoining_date){
      this.postUnPauseSubscription(this.state.rejoining_date, this.state.subscription_id, this.props);
      
    }
    else{
      alert("Please Enter Date")
    }

    this.currentHomebatches()
      this.customerSubscriptions()
    
  }

  postUnPauseSubscription(rejoining_date, subscription_id, props){
    this.setState({dialog_unpause_open: false});
    var date = moment(rejoining_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY/MM/DD")
    const url = `${getLocationOrigin()}/subscriptionpause/unpause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'rejoining_date': date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
        
       })
       .then(this.currentHomebatches())
       .then(this.customerSubscriptions())
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  

  missedCallsms(props) {
    const url = `${getLocationOrigin()}/lead/lead_missed_call_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  postPauseSubscription(pause_date, pause_start, pause_type, subscription_id, props){
    if(pause_start == ''){
      pause_start = moment().toDate()
    }
    this.setState({dialog_open: false});
    var date = moment(pause_date, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    var start_date = moment(pause_start, ["DD-MM-YYYY", "DD/MM/YYYY","YYYY/MM/DD","YYYY-MM-DD"], true).format("YYYY-MM-DD")
    const url = `${getLocationOrigin()}/subscriptionpause/pause_subscription/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                         'pause_date': date,
                         'pause_type': pause_type,
                         'starting_pause_date': start_date,
                         'subscription_id':subscription_id,
                       });
    return fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(function(response){
        alert(response.Message);
       })
       .then(this.currentHomebatches())
       .then(this.customerSubscriptions())
       .catch(error => {
         console.log(error);
         alert(error.message);
       });
  }

  venueSms(props) {
    const url = `${getLocationOrigin()}/lead/send_venue_sms/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({'customer_id': this.state.id});
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){
          alert(response.message);
      })
      .catch(error => {
        console.log(error);
        console.log(error.message);
      });
  }

  connectCall(mobile_no) {
    const url = `${getLocationOrigin()}/calls/connect_customer/`;
    const options = {...defaultOptions};
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                                        'customer_no': mobile_no,
                                        'source':'CM'
                                          });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                     
          alert(response.message);
          // props.history.goBack();
      })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
    }  

    passToWhatsapp(mobile_no) {
      if(window.innerWidth < 992){
        window.open(`https://api.whatsapp.com/send?phone=91${mobile_no}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`
        ,'_blank')
      }
      else{
        window.open(`https://web.whatsapp.com/send?phone=91${mobile_no}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`
        ,'_blank')
      }
    }

    verifyStudent(type){
      if(type == 'AddVerification'){
        this.setState({addVerification:true},()=>this.getdetailsforverification())
      }
      if(type == 'EditVerification'){
        this.setState({editVerification:true})
        this.getdetailsforverification()
        this.setdataforverification()
      }
      if(type == 'verified'){
        var msg = `Do You Want to Continue ?`;
        var result = confirm(msg);
        if (result == true){
          this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
        }
      }
      if(type == 'not_verified'){
        var msg = `Do You Want to Continue ?`;
        var result = confirm(msg);
        if (result == true){
          this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
        }
      }
      if(type == 'cancel_verification'){
        var msg = `Do You Want to Cancel Verification ?`;
        var result = confirm(msg);
        if (result == true){
          this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
        }
      }
      if(type == 'upload_photo'){
        if(this.state.file){
          var msg = `Do You Want to Upload Photo ?`;
          var result = confirm(msg);
          if (result == true){
            this.setStudentVerified(this.state.profile_data[this.state.id].id,type)
          }
        }
        else{
          alert('Please Select a photo to Upload')
        }
      }
    }

    setStudentVerified(customer_id,type){
      const url = `${getLocationOrigin()}/customer_list/get_customer_verified/`;
      const options = {...defaultOptions};
      options['method'] = 'post';      
      var formData = new FormData();
      formData.append('customer_id',customer_id);
      formData.append('v_type',type);
      formData.append('file',this.state.file);      
      options['body'] = formData

      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          alert(data.message)
          this.setState({verified: false,file:'',open_file:false},()=>this.customerFulldetails())
         })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    fileHandler = (event) => {
      let file = event.target.files[0];
      this.setState({file :file});
    }

    validateStudentInfo(type){
      if(type == 'size'){
        if(this.state.jersey_size.length > 0 && !isNaN(this.state.jersey_size)){
          this.postStudentInfo(type,this.state.jersey_size)
        }
        else{
          alert("Invalid Entry")
        }
      }
      if(type == 'kits'){
        if(this.state.no_of_kits.length > 0 && !isNaN(this.state.no_of_kits)){
          this.postStudentInfo(type,this.state.no_of_kits)
        }
        else{
          alert("Invalid Entry")
        }
      }
      if(type == 'percent'){
        if(this.state.scholar_percent.length > 0 && !isNaN(this.state.scholar_percent)){
          this.postStudentInfo(type,this.state.scholar_percent)
        }
        else{
          alert("Invalid Entry")
        }
      }
    }
    
    postStudentInfo(type,value){
      const url = `${getLocationOrigin()}/customer_list/save_student_info/`;
      const options = {...defaultOptions};
      options['method'] = 'post';
      options['headers'] = {'content-type': 'application/json'}
      options['body'] = JSON.stringify({
                                          'customer_id': this.state.profile_data[this.state.id].id,
                                          'info_type': type,
                                          'value': value
                                            });
      console.log('Going to fetch');
      return fetch(url, options)
        .then(checkStatus)
        .then(parseJSON)
        .then(data => {
          alert(data.message)
          this.setState({edit_kit: false, edit_size: false, edit_percent: false})
          this.switchProfile(this.state.profile_data[this.state.id].id)
         })
        .catch(error => {
          console.log(error);
          alert(error.message);
        });
    }

    getdetailsforverification(){
      console.log('getdetailsforverification ')
      const url = `${getLocationOrigin()}/customer_list/get_details_for_customer_verification/`;
      const options = {...defaultOptions};

      return fetch(url, options)
         .then(checkStatus)
         .then(parseJSON)
         .then(data => this.setState({venue_list:data.venue_list,member_types:data.member_types}))
         .catch(error => error);
    }

    handleInputChange(event) {
      console.log('handleChange..')
      console.log(event.target.value)
      const name = event.target.name;
      var new_selected_one = Object.assign({}, this.state.verification_details);
      new_selected_one[name] = event.target.value
      this.setState({verification_details: new_selected_one});
    }

    handleexpdate(date) {
      this.setState({end_date:date})
    }

    imageChange = (event) => {
      let file = event.target.files[0];
      this.setState({card_image :file});
    }

    handleVerifyClose=()=>{
      this.setState({addVerification:false,editVerification:false,
                      verification_details:{
                            selected_venue_id:'',
                            member_type:'',
                            card_number:'',},end_date:'',card_image:''})
    }

    addverification(){
      console.log('verification_details')
      if(this.state.verification_details.selected_venue_id == ''){
        alert("Please select a venue")
      }
      else if(this.state.end_date == ''){
        alert("Please select an end date")
      }
      else{
        var end_date = moment(this.state.end_date).format('YYYY-MM-DD')
        const url = `${getLocationOrigin()}/customer_list/add_verification_for_customer/`;
        const options = {...defaultOptions};
        options['method'] = 'post';      
        var formData = new FormData();
        formData.append('customer_id',this.state.profile_data[this.state.id].id);
        formData.append('venue_id',this.state.verification_details.selected_venue_id);
        formData.append('member_type',this.state.verification_details.member_type);
        formData.append('card_image',this.state.card_image);
        formData.append('card_number',this.state.verification_details.card_number);
        formData.append('end_date',end_date);
        options['body'] = formData

        console.log('Going to fetch');
        return fetch(url, options)
          .then(checkStatus)
          .then(parseJSON)
          .then(data => {
            alert(data.message)
            this.setState({addVerification:false,editVerification:false,end_date:'',card_image:'',
                          verification_details:{
                            selected_venue_id:'',
                            member_type:'',
                            card_number:''}},()=>this.customerFulldetails())
           })
          .catch(error => {
            console.log(error);
            alert(error.message);
          });
      }
    }

    setdataforverification(){
      console.log("setdataforverification")
      let venue_id = this.state.community_member_status.venue_id
      let member_type = this.state.community_member_status.member_type
      let end_date = moment(this.state.community_member_status.end_date)
      let card_number = this.state.community_member_status.card_number
      this.setState({end_date:end_date,
                          verification_details:{
                            selected_venue_id:venue_id,
                            member_type:member_type,
                            card_number:card_number}})
    }





  renderTabButtons(active_tab) {
      
    
      return(
                <div style={{justifyContent: 'center', padding: '1%', display: 'flex', }} className="col-md-12">
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==1)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==1) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==1)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==1?'active':''}`} onClick={()=>this.handleTabClick(1)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Leads</span>  
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==2)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==2) ? '' :'0 6px 4px -4px #000', width: '33%', color: (active_tab==2)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==2?'active':''}`} onClick={()=>this.handleTabClick(2)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}> Bookings</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==3)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==3) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==3)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==3?'active':''}`} onClick={()=>this.handleTabClick(3)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Subscriptions</span>
                  </div> 
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==4)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==4) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==4)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==4?'active':''}`} onClick={()=>this.handleTabClick(4)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Support tickets history</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==5)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==5) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==5)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==5?'active':''}`} onClick={()=>this.handleTabClick(5)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Session feedbacks history</span>
                  </div> 
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==6)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==6) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==6)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==6?'active':''}`} onClick={()=>this.handleTabClick(6)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Attendence history</span>
                  </div>
                  <div className="col-md-4" style={{height: '54px', border: '1px solid #eee', backgroundColor: (active_tab==7)? '#fff':'#f2f2f2', borderTop: '0px', textAlign: 'center', paddingTop: '20px',  boxShadow: (active_tab==7) ? '' : '0 6px 4px -4px #000', width: '33%', color: (active_tab==7)? '#FC427B' :'#000', padding: '1%'}} className={`button  ${active_tab==7?'active':''}`} onClick={()=>this.handleTabClick(7)}>
                      <span style={{fontSize: '100%', fontWeight: 600,}}>Activity history</span>
                  </div>                                                                          
                </div>
      )
    }


  render() {
    
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleSubmit}
      />,
    ];

    const unpause_actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleSubmitUnpause}
      />,
    ];

    const photo_dialog = [
      <FlatButton
        label="Close"
        primary={true}
        onClick={this.handleClose}
      />,
    ]; 

    const add_verification = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleVerifyClose}
        labelStyle={{color:'red'}}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.addverification}
        labelStyle={{color:'green'}}
      />,
    ];

    const edit_verification = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleVerifyClose}
        labelStyle={{color:'red'}}
      />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.addverification}
        labelStyle={{color:'green'}}
      />,
    ];
    
    return(
      <div style={styles.container}>
      { this.state.profile_data ? 
        <div className="row col-md-12 table-bordered" style={styles.table} style={{flexDirection:'row'}}>
            <h4 style={{textAlign:'center'}}>Other Profiles</h4>
            <div className="profile_header col-md-12 " style={{flexDirection: 'row', justifyContent: 'space-between'}}>
                  {
                    this.state.profile_list.map((list, index)=>(
                      <div  className="col-md-2 col9" key={index} style={{display: 'flex' ,flexDirection:'row', alignSelf: 'center', marginBottom: '4px', flexDirection: 'column', float: 'right',paddingLeft: '5%'}} className="col-md-2 col-xs-3" onClick={()=>{this.switchProfile(list.id, this.props)}}>
          
                        <Avatar size={60} src={list.photo.includes('http') ? list.photo : 'https://api.sporthood.in'+list.photo} style={{display:'flex',alignItems:'center',border:'thick solid',borderColor:(list.selected == true) ? 'green':'white',borderWidth:'3px',overflow:'hidden',borderRadius:'50%',alignSelf:'center'}}/>
                         <span style={{fontSize: '100%', fontWeight: 600, paddingTop: '1%', alignSelf: 'center' }} onClick={()=>{this.switchProfile(list.id, this.props)}}>{list.name}</span>

                      </div>))
                  }
               <div style={{flexDirection: 'column', display:'flex'}} onClick={(e) => this.onClicked('ChildProfile')}>   
                <button className="btn" style={{border: 'none', backgroundColor: '#fff', float: 'left', marginTop: '13px',paddingLeft:'0px'}}>
                  <i className="fa fa-plus-circle" style={{fontSize: 'large'}}></i>
                  <span style={{fontSize: '100%', fontWeight: 600}}>Add profile</span>
                </button>
               </div>                           
            </div>  
            {/*<div style={{border: '1px solid #eee',flexDirection:'row',display: 'flex', justifyContent: 'space-around',width:'100%'}} className="col-md-12" >

                <div className="photo_section" style={{flexDirection: 'column', display: 'flex', marginTop: '3px',width:'28%'}}>
                  <div style={{flexDirection: 'row'}}>
                    <Avatar size={90} src={this.state.profile_data[this.state.id].photo.includes('http')? this.state.profile_data[this.state.id].photo : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].photo} />
               
                  </div>
                  <span style={{fontWeight: 600, paddingTop: '1%', color: '#FC427B'}}>{this.state.profile_data[this.state.id].name}</span>
                  <span style={{fontWeight: 600, paddingTop: '1%', color: '#FC427B'}}>{this.state.profile_data[this.state.id].mobile_no.slice(0,3)+'***'+this.state.profile_data[this.state.id].mobile_no.slice(6,10)}</span>
                  <div className="col-md-4" onClick={(e) => this.onClicked('EditProfile')}>
                      <div style={{backgroundColor: '#FDD60B', color: '#000',marginBottom: '1px',borderRadius: '4px', borderWidth: '0px',padding:'6px'}}>
                       Edit Profile
                    </div>
                  </div>
                </div>

                <div  style={{flexDirection: 'column', display: 'flex', marginTop: '1px',width:'35%'}}>
                    <div style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].customer_type) ?'#000' : '#FF0000', whiteSpace: 'nowrap',}}>
                    <span>Type:</span> <span>{this.state.profile_data[this.state.id].customer_type ? this.state.profile_data[this.state.id].customer_type : "No data"}</span></div>
                    <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].email)? '#000': '#FF0000'}}>
                      <div>Email:</div> <div>{this.state.profile_data[this.state.id].email ? this.state.profile_data[this.state.id].email : "No data"}</div>
                    </div>
                    <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].date_of_birth)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>DOB: {this.state.profile_data[this.state.id].date_of_birth ? this.state.profile_data[this.state.id].date_of_birth : "No data"}</span>
                    <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].gender)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Gender: {this.state.profile_data[this.state.id].gender ? this.state.profile_data[this.state.id].gender : "No data"}</span>
                    <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].source)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Lead Source: {this.state.profile_data[this.state.id].source ? this.state.profile_data[this.state.id].source : "No data"}</span>
                   {
                    this.state.profile_data[this.state.id].customer_type == 'Child' ?
                    <div style={{flexDirection: 'column', display: 'flex', justifyContent: 'space-between',}}>
                      <span style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].jersey_size)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>Size: {this.state.profile_data[this.state.id].jersey_size ? this.state.profile_data[this.state.id].jersey_size : "Nil"}</span>
                      <span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px',color: (this.state.profile_data[this.state.id].school)? '#000' : '#FF0000'}}>School: {this.state.profile_data[this.state.id].school ? this.state.profile_data[this.state.id].school : "Nil"}</span>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,  marginTop: '5px',color: (this.state.profile_data[this.state.id].level.length>0)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>
                        <div>Gamelevel:</div> <div>{(this.state.profile_data[this.state.id].level.length > 0)  ? this.state.profile_data[this.state.id].level[0].game +":"+this.state.profile_data[this.state.id].level[0].game_level : "Nil"}</div>
                      </div>
                    </div>
                    :
                    <div></div>

                   }
                </div>
                
                  {
                  this.state.profile_data[this.state.id].customer_type == 'Child' &&
                    <div style={{flexDirection: 'column', display: 'flex',width:'16%', marginTop: '3px'}}>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,color: (this.state.profile_data[this.state.id].father_name)? '#000':'#FF0000'}}>
                        <div>Father's Name:</div>
                        <div>{this.state.profile_data[this.state.id].father_name ? this.state.profile_data[this.state.id].father_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].father_number)? '#000':'#FF0000'}}>
                        <div>Father's  No:</div> <div>{this.state.profile_data[this.state.id].father_number ? this.state.profile_data[this.state.id].father_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', fontWeight: 600,display: 'flex',flexWrap: 'wrap', marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_name)? '#000':'#FF0000'}}>
                        <div>Mothers Name:</div> <div>{this.state.profile_data[this.state.id].mother_name ? this.state.profile_data[this.state.id].mother_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_number)? '#000':'#FF0000'}}>
                        <div>Mothers No:</div> <div>{this.state.profile_data[this.state.id].mother_number ? this.state.profile_data[this.state.id].mother_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].apartment)? '#000':'#FF0000'}}>
                        <div>Apartment:</div> <div>{this.state.profile_data[this.state.id].apartment ? this.state.profile_data[this.state.id].apartment : "Nil"}</div>
                      </div>
                      <span style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].address)? '#000':'#FF0000' }}>Address: {this.state.profile_data[this.state.id].address ? this.state.profile_data[this.state.id].address.substring(0,70) : "Nil"}</span>
                   
                    </div>
                }
                <div  style={this.state.profile_data[this.state.id].customer_type == 'Child'? { flexDirection: 'column',  marginBottom: '2px', display: 'flex', alignItems: 'center', marginTop: '0px'}:{flexDirection: 'column',  marginBottom: '1px', display: 'flex', alignItems: 'center', marginTop: '5px'}} >
                         
                          <div >
                            
                              <button onClick={(e) => this.onClicked('EditLead')}
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '1px', 
                                  borderRadius: '4px', borderWidth: '0px',padding:'6px'
                                  
                              }}>
                              Edit Lead
                            </button>
                          </div>
                          <div>
                              <button 
                              onClick={(e) => this.onClicked('ScheduleDemo')}
                              style={{
                                  backgroundColor: '#FDD60B',
                                  color: '#000',
                                  marginBottom: '1px',
                                  borderRadius: '4px', borderWidth: '0px',padding:'6px'
                              }}>
                              Schedule Demo
                            </button>
                          </div>
                          <div >
                           <button  style={{backgroundColor: '#FDD60B',color: '#000', borderColor: '#FDD60B', marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px'}}
                            type="button" onClick={()=>this.venueSms(this.props)}>Venue SMS</button>
                          </div>
                          <div >
                           <button style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B', marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',color: '#000'}}
                            type="button" onClick={()=>this.missedCallsms(this.props)}>Missed Call SMS</button>
                          </div>
                             <a
                                href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`}
                                target="_blank"
                                className="col-md-12"
                                style={{
                                    border: '1px solid rgb(37, 211, 102)',
                                    color: '#000',
                                    marginBottom: '1px',
                                    fontSize:'100%',
                                    width:'15vw',
                                    padding:'2%'
                                }}>

                                <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginBottom: '2px',marginRight:'0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                Football Welcome
                            </a>

                             <a
                                href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings%20from%20*Sporthood*%21%C2%A0Thanks%20for%20showing%20interest%20in%20playing%20badminton%20with%20Sporthood.%C2%A0%0A%0A*Benefits%20of%20playing%20with%20Sporthood*%0A-%20Skill%20matched%20games%20held%20on%20daily%20basis%0A-%20Certified%20trainers%20help%20improve%20your%20game%20%26%20fitness%0A-%20Leaderboard%20%26%20progress%20monitoring%0A-%20Hoods%20located%20across%20the%20city%0A%0AVisit%20our%20website%20http%3A%2F%2Fbit.ly%2F2DhKeup%20to%20join%20a%20game%20now%21%0A%0AOr%20I%20can%20help%20schedule%20a%20*ONE%20TIME%20FREE%20DEMO*%20for%20the%20same%20on%20your%20confirmation.`}
                                target="_blank"
                                className="col-md-12"
                                style={{
                                    border: '1px solid rgb(37, 211, 102)',
                                    color: '#000',
                                    marginBottom: '1px',
                                    fontSize:'100%',
                                    width:'18vw',
                                    padding:'2%'
                                }}>
                                
                                <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginBottom: '2px',marginRight:'0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                                Badminton Welcome                               
                            </a>

                            <button className='btn btn-success' onClick={()=>{this.connectCall(this.state.profile_data[this.state.id].mobile_no)}}>
                              <i style={{fontSize:'1.9vw', color: 'white',marginBottom: '2px',marginRight:'0.5vw'}} className='fa fa-phone fa-2x' aria-hidden="true"></i>
                              Call Customer
                            </button>                            

                            <a style={{whiteSpace: 'nowrap'}}
                              href={`whatsapp://send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation. `}>
                              Whatsapp Desktop App
                            </a>
                </div>
            </div>*/}
            

  <div style={{width:'100%'}}>
    <table style={{width:'100%',marginBottom:'2%'}}>
      <tr>
        <td>
            <div>
              <Avatar size={90} src={this.state.profile_data[this.state.id].photo.includes('http')? this.state.profile_data[this.state.id].photo : 'https://api.sporthood.in'+this.state.profile_data[this.state.id].photo} />
            </div>
        </td>
        <td>
          <tr>  <span style={{fontWeight: 600, paddingTop: '1%', color: '#000'}}>{this.state.profile_data[this.state.id].name}</span></tr>
          <tr>  <span style={{fontWeight: 600, paddingTop: '1%', color: '#000'}}>{this.state.profile_data[this.state.id].mobile_no.slice(0,3)+'***'+this.state.profile_data[this.state.id].mobile_no.slice(6,10)}</span></tr>
          <tr>  
               <div onClick={(e) => this.onClicked('EditProfile')} style={{backgroundColor: '#FDD60B', color: '#000',marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',textAlign:'center'}}>
                       Edit Profile
               </div>
          </tr>
          <tr>
               <div onClick={(e) => this.onClicked('EditLead')} style={{backgroundColor: '#FDD60B',color: '#000',marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',textAlign:'center'}}>
                      Edit Lead
               </div>
          </tr>
        </td>
        <td>
          <tr>
          {this.state.community_member_status && this.state.community_member_status.is_verified ? 
              <div onClick={() => this.verifyStudent('EditVerification')} style={{backgroundColor: '#FDD60B', color: '#000',marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',textAlign:'center',cursor:'pointer'}}>
                       Edit Verification
               </div>
               : 
               <div onClick={() => this.verifyStudent('AddVerification')} style={{backgroundColor: '#FDD60B', color: '#000',marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',textAlign:'center',cursor:'pointer'}}>
                       Add Verification
               </div>
          }      
          </tr>
          <tr>
              <div onClick={(e) => this.onClicked('ScheduleDemo')} style={{backgroundColor: '#FDD60B',color: '#000',marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',textAlign:'center'}}>
                        Schedule Demo
              </div>
          </tr>
          <tr>
              <button style={{backgroundColor: '#FDD60B',color: '#000', borderColor: '#FDD60B', marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px',width:'100%'}}
                      type="button" onClick={()=>this.venueSms(this.props)}>Venue SMS</button>
          </tr>
          <tr>
              <button style={{backgroundColor: '#FDD60B',color: '#000', borderColor: '#FDD60B', marginBottom: '2px',borderRadius: '4px', borderWidth: '0px',padding:'6px'}}                         
                      type="button" onClick={()=>this.missedCallsms(this.props)}>Missed Call SMS</button>
          </tr>
        </td> 
      </tr>
    </table>

    {this.state.addVerification &&
      <Dialog
          actions={add_verification}
          modal={false}
          open={this.state.addVerification}
          onRequestClose={this.handleVerifyClose}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >

        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Add Verification </h4>
        </div>
        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Customer</div>
          <div className="col-md-6 col-xs-8">
            {this.state.profile_data[this.state.id].name} : {this.state.profile_data[this.state.id].mobile_no}
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Venue</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="selected_venue_id" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} >
              <option>--select a venue--</option>
              {this.state.venue_list.map((venue,index) =>
              <option key={venue.id} value={venue.id}>{venue.value}</option>
              )} 
            </select>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Member Type</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="member_type" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} >
              <option>--select member type--</option>
              {this.state.member_types.map((member,index) =>
              <option key={member.id} value={member.id}>{member.type}</option>
              )}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Image</div>
          <div className="col-md-6 col-xs-8">
            <input type="file" className="form-control" name= "verification_photo" style={{marginRight:'5px'}} 
            onChange={this.imageChange.bind(this)}/>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Number</div>
          <div className="col-md-6 col-xs-8">
            <input type="text" className="form-control" placeholder="enter card Number" 
              name= "card_number" onChange={(e)=>this.handleInputChange(e)} 
              />
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'3%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>End Date</div>
          <div className="col-md-6 col-xs-8">
            <DatePicker selected={this.state.end_date} onChange={this.handleexpdate} dateFormat="DD/MM/YYYY"/>
          </div>
        </div>
      </Dialog>
    }

    {this.state.community_member_status ?
      <Dialog
          actions={edit_verification}
          modal={false}
          open={this.state.editVerification}
          onRequestClose={this.handleVerifyClose}
          style ={{zIndex:'10000000'}}
          bodyStyle ={{overflow:'inherit'}}
        >
        <div className="col-md-12 col-xs-12" style={styles.sub_header}>
          <h4 style={{textAlign:'center',fontWeight:'900'}}> Edit Verification </h4>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Customer</div>
          <div className="col-md-6 col-xs-8">
            {this.state.profile_data[this.state.id].name} : {this.state.profile_data[this.state.id].mobile_no}
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Venue</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="selected_venue_id" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} value={this.state.verification_details.selected_venue_id}>
              <option>--select a venue--</option>
              {this.state.venue_list.map((venue,index) =>
              <option key={venue.id} value={venue.id}>{venue.value}</option>
              )} 
            </select>
          </div>
        </div>

        <div className='col-md-12 col-xs-12' style={{marginBottom:'2%'}}>
          <div className='col-md-6 col-xs-4' style={{fontWeight:'600'}}>Member Type</div>
          <div className='col-md-6 col-xs-8'>
            <select className="form-control" name="member_type" style={{width:'100%',padding:'6px'}}
                  onChange={(e)=>this.handleInputChange(e)} value={this.state.verification_details.member_type}>
              <option>--select member type--</option>
              {this.state.member_types.map((member,index) =>
              <option key={member.id} value={member.id}>{member.type}</option>
              )}
            </select>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Image</div>
          <div className="col-md-6 col-xs-8">
            <input type="file" className="form-control" name= "verification_photo" style={{marginRight:'5px'}} 
            onChange={this.imageChange.bind(this)}/>
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'2%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>Card Number</div>
          <div className="col-md-6 col-xs-8">
            <input type="text" className="form-control" placeholder="enter card Number" value={this.state.verification_details.card_number}
              name= "card_number" onChange={(e)=>this.handleInputChange(e)} 
              />
          </div>
        </div>

        <div className="col-md-12 col-xs-12" style={{marginBottom:'3%'}}>
          <div className="col-md-6 col-xs-4" style={{fontWeight:'600'}}>End Date</div>
          <div className="col-md-6 col-xs-8">
            <DatePicker selected={this.state.end_date} onChange={this.handleexpdate} dateFormat="DD/MM/YYYY"/>
          </div>
        </div>

      </Dialog>
      :''
    }

     
     {this.state.community_member_status &&
      <div style={{marginTop:'1%',marginBottom:'1%'}}>
        {this.state.community_member_status.is_member && this.state.community_member_status.is_verified ?
          <div className="col-xs-12 col-md-6" style={{width:'100%',display:'flex',flexDirection:'row',fontWeight:900}}>
            <i className="fa fa-check-circle" style={{color:'green',fontSize:'25px',paddingRight:'5px'}} aria-hidden="true"></i>
            <span style={{paddingRight:'5px',paddingTop:'2px'}}>{this.state.community_member_status.venue_name} Verified Customer</span>
            {!this.state.open_file &&
            <button name="cancel_verification" style={{marginRight:'5px'}}  onClick={()=>this.verifyStudent('cancel_verification')}>Cancel</button> 
            }
            {this.state.community_member_status.card_imge &&
              <button name="view_photo" onClick={()=>this.setState({view_photo:true})}><i className="fa fa-eye" style={{paddingRight:'2px'}} aria-hidden="true"></i>View Photo</button>
              //<button name="add_photo" onClick={()=>this.setState({open_file:true})}><i className="fa fa-camera" style={{paddingRight:'2px'}} aria-hidden="true"></i>Add Photo</button>
            }
          </div>
         :
         this.state.community_member_status.is_member && !this.state.community_member_status.is_verified ?
          <div className="col-xs-12 col-md-6" style={{width:'100%',display:'flex',flexDirection:'row'}}>
            <span style={{paddingRight:'5px',paddingTop:'5px',fontWeight:900}}> Is this a verfied customer of {this.state.community_member_status.venue_name} ?</span>
            <button name="verified" onClick={()=>this.verifyStudent('verified')} className="btn btn-success">Yes</button>
            <button name="not_verified" onClick={()=>this.verifyStudent('not_verified')} className="btn btn-danger">No</button>        
          </div>
          :null
        }
      </div>
      }
      {/*this.state.open_file &&
        <div className="col-xs-12 col-md-4" style={{display:'flex',flexDirection:'row',fontWeight:900,marginTop:'1%'}}>
          <input type="file" className="form-control" name= "verification_photo" style={{marginRight:'5px'}} 
                  onChange={this.fileHandler.bind(this)}/>
          <button name="add_photo" onClick={()=>this.verifyStudent('upload_photo')} style={{marginRight:'5px'}}>Upload</button>
          <button onClick={()=>this.setState({open_file:false,file:''})}>Close</button>       
        </div>
      */}
      {this.state.view_photo &&
        <Dialog
            title="Verification Photo"
            actions={photo_dialog}
            modal={false}
            open={this.state.view_photo}
            onRequestClose={this.handleClose}
            style ={{zIndex:'10000000'}}
            bodyStyle ={{overflow:'inherit'}}
          >
          <div className="col-md-12" style={{textAlign:'center',marginBottom:'3%'}}>
            <img width="200" height="200" src={this.state.community_member_status.card_imge.includes('http') ? this.state.community_member_status.card_imge : 'https://api.sporthood.in'+this.state.community_member_status.card_imge} />
          </div>
        </Dialog>
      }   

    <table style={{width:'100%'}}>
           <tr>
           <td style={{width:'50%'}}>
            <div>
              <div className="col-xs-12 col-md-6">
                <div style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].customer_type) ?'#000' : '#FF0000', whiteSpace: 'nowrap',}}>
                <span>Type:</span> <span>{this.state.profile_data[this.state.id].customer_type ? this.state.profile_data[this.state.id].customer_type : "No data"}</span></div>
                <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].email)? '#000': '#FF0000'}}>
                  <div>Email:</div> <div>{this.state.profile_data[this.state.id].email ? this.state.profile_data[this.state.id].email : "No data"}</div>
                </div>
                <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].date_of_birth)? '#000':'#FF0000', whiteSpace: 'nowrap',}}>DOB: {this.state.profile_data[this.state.id].date_of_birth ? this.state.profile_data[this.state.id].date_of_birth : "No data"}</span></div>
                <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].gender)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Gender: {this.state.profile_data[this.state.id].gender ? this.state.profile_data[this.state.id].gender : "No data"}</span></div>
                <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: (this.state.profile_data[this.state.id].source)? '#000' : '#FF0000', whiteSpace: 'nowrap',}}>Lead Source: {this.state.profile_data[this.state.id].source ? this.state.profile_data[this.state.id].source : "No data"}</span></div>
                <div><span style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px', color: '#000', whiteSpace: 'nowrap'}}>Credit Balance: {this.state.credit_balance} </span></div>
              </div> 
             {
              this.state.profile_data[this.state.id].customer_type == 'Child' ?

              <div className="col-xs-12 col-md-6">
                <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,  marginTop: '5px', whiteSpace: 'nowrap',}}>
                  <div style={{color: 'black'}}> Jersey Size: </div> &nbsp;

                    {
                      this.state.edit_size ?
                        <input type = 'number' value = {this.state.jersey_size} onChange = {(event)=>this.setState({jersey_size: event.target.value})} />
                      :
                        !this.state.profile_data[this.state.id].student_info ? 
                          <span style={{color: 'grey'}}>no data available</span> 
                        : <span style={{color: '#FF0000'}}>{this.state.profile_data[this.state.id].student_info.jersey_size}</span> 
                    }
                    {
                      this.state.edit_size ?
                        <div>
                          <button onClick={()=>this.validateStudentInfo('size')}> save </button>
                          <button onClick={()=>this.setState({edit_size: false})}> cancel </button>
                        </div>
                      :
                        <div> &nbsp;<i className="fa fa-pencil" aria-hidden="true" onClick={()=>this.setState({edit_size: true})} style={{cursor: 'pointer', color: 'green', border: '1px solid green', padding: '2px', borderRadius: '3px'}}></i></div>
                    }
                  </div>
                  <div style={{fontSize: '90%', fontWeight: 600,  marginTop: '5px'}}>
                    <span style={{color: 'black'}}>No. of kits received:</span> &nbsp;

                    {
                      this.state.edit_kit ?
                        <input type = 'number' value = {this.state.no_of_kits} onChange = {(event)=>this.setState({no_of_kits: event.target.value})}/>
                      :
                        !this.state.profile_data[this.state.id].student_info ? 
                          <span style={{color: 'grey'}}>no data available</span> 
                        : <span style={{color: '#FF0000'}}>{this.state.profile_data[this.state.id].student_info.no_of_kit_received}</span> 
                    }
                    {
                      this.state.edit_kit ?
                        <div>
                          <button onClick={()=>this.validateStudentInfo('kits')}> save </button>
                          <button onClick={()=>this.setState({edit_kit: false})}> cancel </button>
                        </div>
                      :
                        <span>&nbsp;<i className="fa fa-pencil" aria-hidden="true" onClick={()=>this.setState({edit_kit: true})} style={{cursor: 'pointer', color: 'green', border: '1px solid green', padding: '2px', borderRadius: '3px'}}></i></span>
                    }
                  </div>
                  <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600,  marginTop: '5px', whiteSpace: 'nowrap',}}>
                    <div style={{color: 'black'}}>Scholarship Percentage:</div> &nbsp;

                    {
                      this.state.edit_percent ?
                        <input type = 'number' value = {this.state.scholar_percent} onChange = {(event)=>this.setState({scholar_percent: event.target.value})}/>
                      :
                        !this.state.profile_data[this.state.id].student_info ? 
                          <span style={{color: 'grey'}}>no data available</span> 
                        : <span style={{color: '#FF0000'}}>{this.state.profile_data[this.state.id].student_info.scholarship_percentage}</span> 
                    }
                    {
                      this.state.edit_percent ?
                        <div>
                          <button onClick={()=>this.validateStudentInfo('percent')}> save </button>
                          <button onClick={()=>this.setState({edit_percent: false})}> cancel </button>
                        </div>
                      :
                        <div> &nbsp;<i className="fa fa-pencil" aria-hidden="true" onClick={()=>this.setState({edit_percent: true})} style={{cursor: 'pointer', color: 'green', border: '1px solid green', padding: '2px', borderRadius: '3px'}}></i></div>
                    }
                  </div> 
              </div>
              :
                <div></div>                    
              }
            </div>
           </td>
           <td>
            {
                  this.state.profile_data[this.state.id].customer_type == 'Child' &&
                  <div>
                    <div className="col-xs-12 col-md-6">
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px',color: (this.state.profile_data[this.state.id].father_name)? '#000':'#FF0000'}}>
                        <div>Father's Name:</div>
                        <div>{this.state.profile_data[this.state.id].father_name ? this.state.profile_data[this.state.id].father_name : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].father_number)? '#000':'#FF0000'}}>
                        <div>Father's  No:</div> <div>{this.state.profile_data[this.state.id].father_number ? this.state.profile_data[this.state.id].father_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%', fontWeight: 600,display: 'flex',flexWrap: 'wrap', marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_name)? '#000':'#FF0000'}}>
                        <div>Mothers Name:</div> <div>{this.state.profile_data[this.state.id].mother_name ? this.state.profile_data[this.state.id].mother_name : "Nil"}</div>
                      </div>
                    </div>
                    <div className="col-xs-12 col-md-6">
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].mother_number)? '#000':'#FF0000'}}>
                        <div>Mothers No:</div> <div>{this.state.profile_data[this.state.id].mother_number ? this.state.profile_data[this.state.id].mother_number : "Nil"}</div>
                      </div>
                      <div style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].apartment)? '#000':'#FF0000'}}>
                        <div>Apartment:</div> <div>{this.state.profile_data[this.state.id].apartment ? this.state.profile_data[this.state.id].apartment : "Nil"}</div>
                      </div>
                      <span style={{fontSize: '90%',display: 'flex',flexWrap: 'wrap', fontWeight: 600, marginTop: '5px', color: (this.state.profile_data[this.state.id].address)? '#000':'#FF0000' }}>Address: {this.state.profile_data[this.state.id].address ? this.state.profile_data[this.state.id].address.substring(0,70) : "Nil"}</span>                   
                    </div>
                  </div>
                }                
            </td>
          </tr>
  
        <tr>
          <td style={{paddingTop:'10px'}}>
            <div className="col-xs-12 col-md-6">
                <div>
                    <button style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',textAlign:'left',backgroundColor: '#fff',width:'100%'}}>
                      <a
                        href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Hi%0A%3CCM%20name%3E%20from%20Sporthood%20here`}
                        target="_blank" style={{color: '#000'}}>
                      <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw',marginBottom: '2px'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                      Intro Message </a></button>
                </div>
                <div>
                    <button style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',textAlign:'left',backgroundColor:'#fff',width:'100%'}}>
                      <a
                        href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=We%20run%20a%20network%20of%20neighbourhood%20sports%20clubs%20across%20Bangalore%20%26%20Kochi.%20You%20can%20book%20courts%2C%20join%20for%20training%20sessions%2C%20skill%20matched%20games%2C%20enroll%20your%20kids%20for%20coaching%2C%20all%20from%20our%20mobile%20app.%20www.sporthood.in%2Fapp`}
                        target="_blank" style={{color: '#000'}}>                             
                      <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw',marginBottom:'2px'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                      About Us Message </a></button>
                </div>
            </div>
            <div className="col-xs-12 col-md-6">
                 <div>
                    <button  style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',backgroundColor: '#fff',textAlign:'left',width:'100%'}}>
                      <a
                        href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings+from+Sporthood%21%C2%A0Thanks+for+showing+interest+in+playing+football+with+Sporthood.%C2%A0%0D%0A%0D%0A*Benefits+of+playing+with+Sporthood*%0D%0A-+Skill+matched+games+held+on+daily+basis%0D%0A-+Certified+trainers+help+improve+your+game+%26+fitness%0D%0A-+Leaderboard+%26+progress+monitoring%0D%0A-+Hoods+located+across+the+city%0D%0A%0D%0AVisit+our+website+http%3A%2F%2Fbit.ly%2F2rQ5k0q+to+join+a+game+now%21%0D%0A%0D%0AOr+I+can+help+schedule+a+ONE+TIME+FREE+DEMO+for+the+same+on+your+confirmation.`}
                        target="_blank" style={{color: '#000'}}>
                        <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginBottom: '2px',marginRight:'0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                        Football Welcome </a></button>
                 </div> 
                 <div>
                    <button style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',backgroundColor: '#fff',textAlign:'left',width:'100%'}}>
                      <a
                        href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=Greetings%20from%20*Sporthood*%21%C2%A0Thanks%20for%20showing%20interest%20in%20playing%20badminton%20with%20Sporthood.%C2%A0%0A%0A*Benefits%20of%20playing%20with%20Sporthood*%0A-%20Skill%20matched%20games%20held%20on%20daily%20basis%0A-%20Certified%20trainers%20help%20improve%20your%20game%20%26%20fitness%0A-%20Leaderboard%20%26%20progress%20monitoring%0A-%20Hoods%20located%20across%20the%20city%0A%0AVisit%20our%20website%20http%3A%2F%2Fbit.ly%2F2DhKeup%20to%20join%20a%20game%20now%21%0A%0AOr%20I%20can%20help%20schedule%20a%20*ONE%20TIME%20FREE%20DEMO*%20for%20the%20same%20on%20your%20confirmation.`}
                        target="_blank" style={{color: '#000'}}>                                
                        <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginBottom: '2px',marginRight:'0.5vw'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                        Badminton Welcome </a></button>
                 </div>
            </div> 
          </td>
          <td>
            <div className='col-xs-12 col-md-6'>              
                <div style={{marginBottom:'5px',marginLeft:'25%'}}>
                    <button className="badge badge-default" style={{marginTop:'5px',backgroundColor:'#32CD32',color:'white',border:'none'}} 
                                onClick={()=>{this.connectCall(this.state.profile_data[this.state.id].mobile_no)}}>
                      <i className='fa fa-phone fa-2x' aria-hidden="true"></i>                             
                    </button> 
                    <button className="badge badge-default" style={{marginTop:'5px',backgroundColor:'#32CD32',color:'white',border:'none',marginLeft:'4%'}}
                               onClick={()=>this.passToWhatsapp(this.state.profile_data[this.state.id].mobile_no)}>
                      <i className="fa fa-whatsapp fa-2x"></i>
                      </button>                          
                </div>
                <div>    
                    <button style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',textAlign:'left',backgroundColor:'#fff',width:'100%'}}>
                    <a
                      href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=We%20provide%20best%20in%20class%20grass%20roots%20coaching%20for%20kids%2C%20in%20partnership%20with%20the%20best%20in%20the%20business.%20`}
                      target="_blank" style={{color: '#000'}}>                     
                    <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw',marginBottom:'2px'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                    Academy Intro </a></button>
                </div>
            </div>
            <div className="col-xs-12 col-md-6">
                <div>
                    <button style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',textAlign:'left',backgroundColor:'#fff',width:'100%'}}>
                    <a
                      href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=We%20have%20sports%20based%20fitness%20programs%20for%20adults%20that%20help%20you%20stay%20fit%20and%20active%20while%20playing%20your%20favourite%20sport.%20Our%20expert%20trainers%20will%20work%20on%20both%20your%20skill%20and%20fitness%20to%20make%20sure%20you%20have%20a%20great%20experience.%20`}
                      target="_blank" style={{color: '#000'}}>
                    <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw',marginBottom:'2px'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                    Training Intro </a></button>
                </div>
                <div>              
                    <button style={{border: '1px solid rgb(37, 211, 102)',marginBottom: '2px',fontSize:'100%',textAlign:'left',backgroundColor:'#fff',width:'100%'}}>
                    <a
                      href={`https://web.whatsapp.com/send?phone=91${this.state.profile_data[this.state.id].mobile_no.slice(this.state.profile_data[this.state.id].mobile_no.length - 10)}&lang=en&text=We%20have%20playing%20memberships%20that%20help%20you%20play%20multiple%20sports%20across%20our%20network%20at%20pocket%20friendly%20rates.%20`}
                      target="_blank" style={{color: '#000'}}>
                    <i style={{fontSize:'1.9vw', color: 'rgb(37, 211, 102)',marginRight: '0.5vw',marginBottom:'2px'}} className="fa fa-whatsapp" aria-hidden="true"></i>
                    Playing Intro </a></button>                                       
                </div>
            </div> 
          </td>
        </tr>         
    </table>
  </div>


          <div className="bottom_tabs col-md-12 " style={{flexDirection:'column',display:'flex', justifyContent: 'space-between', marginTop: '2px', border: '1px solid #eee',width:'100%'}}>
           <div className="col-md-12">
            {this.renderTabButtons(this.state.active_tab)}
          </div> 
          <div className="col-md-12 " style={{ justifyContent: 'space-between'}}>
          {
            (this.state.active_tab==1 ) ?
              <div className="col-md-12 " style={{ backgroundColor: '#fff'}}>
                <div>
                  <div style={{backgroundColor: '#c5c0c0', flexDirection: 'row',display: 'flex', marginBottom: '1%', padding: '1%', height: 'auto'}}>
                    <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                      <span style={{color: '#000', fontWeight: '900' }}>Follow Up Date</span>
                    </div>

                    <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                      <span style={{color: '#000', fontWeight: '900'}}>Buddy</span>
                    </div>

                     <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                      <span style={{color: '#000', fontWeight: '900'}}>Venue</span>
                     </div>

                     <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                      <span style={{color: '#000', fontWeight: '900' }}>Updated On</span>
                    </div>

                     <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                      <span style={{color: '#000', fontWeight: '900'}}>Status</span>
                    </div>

                    <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'40%'}}>
                     <span style={{fontWeight: '900',color: '#000'}}>Comment</span>
                    </div>
                  </div>
                  {
                    this.state.customer_leads.map((lead, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display: 'flex', marginBottom: '1%', padding: '1%', height: 'auto'}}>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>{moment(lead.follow_up_date).format('DD MMM YYYY')}</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{ lead.created_by != null && lead.created_by }</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.venue}</span>
                         </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>{lead.created_on}</span>
                        </div>

                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'20%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{lead.status}</span>
                        </div>

                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px',width:'40%'}}>
                         <span style={{color: '#000', fontWeight: '600'}}>{lead.comment}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
              </div>
            :
            (this.state.active_tab == 2) ?
            <div className="col-md-12 col7" style={{flexDirection: 'column',display: 'flex', backgroundColor: '#fff'}}>
                <div>
                  {
                    this.state.customer_bookings.map((booking, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display: 'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>
                        <div className="col-md-4 col7" style={{justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                        <div style={{color: '#000', fontWeight: '600',marginBottom:'0.5%'}}>{booking.fixture}</div>
                        <div style={{color: '#000', fontWeight: '600'}}>{booking.venue_display_name}</div>
                        </div>
                        
                        <div className="col-md-4 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                        <span style={{color: '#000', fontWeight: '600', }}>{booking.package}</span>
                        </div>
                         <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                            <span style={{color: '#000', fontWeight: '600'}}>{booking.date}</span>
                         </div>
                        <div className="col-md-2 col7" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                           <span style={{color: '#000'}}>Status </span>
                            <span style={{color: '#000', fontWeight: '600'}}>{booking.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :
              (this.state.active_tab == 3) ?
              <div style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '5px', padding: '1%', display: 'flex'}}>
                <div>
                  {
                    this.state.customer_subscriptions.map((data, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', padding: '1%', flexDirection: 'column', marginBottom: '3px'}} className="col-md-12">
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                        <div className="col-md-3" style={{width:'25%'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{data.package}</span>
                        </div>
                        <div className="col-md-3" style={{width:'25%'}}>
                          <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Sessions Left: {data.sessions_left}</span>
                        </div>
                        <div className="col-md-3" style={{width:'25%'}}>
                          <span style={{color: '#000', fontWeight: '600' }}>Start date: {data.start_date}</span>
                        </div>
                        
                        <div className="col-md-3" style={{width:'25%'}}>
                           <button  style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',  borderRadius: '4px', borderWidth: '0px',padding:'6px'}}
                            type="button" ><a href={getLocationOrigin()+"/invoice/download/?subscription_id="+data.id}>Download</a></button>
                          </div>
                        </div>
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                            <div className="col-md-3" style={{width:'25%'}}>
                            <span style={{color: '#000', alignSelf: 'center',fontWeight: '600'}}>{data.gamename} : {data.gamentypename}</span>
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>   
                            <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Total Pause: {data.total_pause}</span>
                            </div>
                            
                            <div className="col-md-3" style={{width:'25%'}}>
                            <span style={{color: '#000', fontWeight: '600'}}>End Date: {data.end_date}</span>
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>
                            {data.homebatch ?
                              <button  style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                              type="button" ><a href={"https://api.sporthood.in/v2/cart/edit_homebatches/?subscription_id="+data.id}>Edit Homebatch</a></button>
                            :
                              <button  style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                              type="button" ><a href={"https://api.sporthood.in/v2/cart/edit_homebatches/?subscription_id="+data.id}>Add Homebatch</a></button>

                            }
                          </div>
                        </div>

                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between',marginBottom:'0.5%'}}>
                            <div className="col-md-3" style={{width:'25%'}}></div>
                            <div className="col-md-3" style={{width:'25%'}}></div>
                            <div className="col-md-3" style={{width:'25%'}}></div>
                            <div className="col-md-3" style={{width:'25%'}}>
                            {
                              data.homebatch &&
                                <div style={{fontWeight: '600',color: '#000'}}>
                                  <span>{data.homebatch.venue_name}</span><br></br>
                                  <span>{data.homebatch.days} &nbsp; {data.homebatch.start_time} - {data.homebatch.end_time}</span>
                                </div>
                            }
                            </div>
                        </div>

                      
                        <div className="col-md-12" style={{flexDirection: 'row', display: 'flex', justifyContent: 'space-between'}}>
                          <div className="col-md-3" style={{width:'25%'}}>   
                          <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Amount: {data.amount}</span>
                          </div>
                          <div className="col-md-3" style={{width:'25%'}}>   
                            <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Used Pause: {data.subscription_pause.length}</span>
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}> 
                            {data.end_date < moment().format("YYYY-MM-DD")?
                              <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Status: Expired</span>
                              :
                            <span style={{color: '#000', justifyContent: 'space-between', fontWeight: '600'}}>Status: {data.status}</span>
                            }
                            </div>
                            <div className="col-md-3" style={{width:'25%'}}>
                          {data.total_pause > -1 ?
                          <div>
                        {data.status === "active" ?
                           <button style={{backgroundColor: '#FDD60B',color:'#3c8dbc', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" onClick={()=>this.setState({dialog_open:true, subscription_id:data.id})}>Pause Subscription</button>
                            :
                            <button style={{backgroundColor: '#FDD60B',color:'#3c8dbc', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" onClick={()=>this.setState({dialog_unpause_open:true, subscription_id:data.id})} >Unpause Subscription</button>
                        }

                          <div>
                            {this.state.subscription_id === data.id &&
                          <Dialog
                                actions={actions}
                                modal={false}
                                open={this.state.dialog_open}
                                onRequestClose={this.handleClose}
                                style ={{zIndex:'10000000'}}

                              >
                                <div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Reason of Pause
                                    </div>
                                    <select name="pause_type" className="col-md-6" style={styles.item_body} onChange={this.handleChange} value={this.state.pause_type}>
                                      { 
                                         Object.keys(this.state.pause_types).map((key,index)=>(
                                           <option key={key} value={key}>{this.state.pause_types[key]}</option>
                                          ))
                                      }
                                    </select>
                                  </div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Date from you want to Pause (DD/MM/YYYY)
                                    </div>
                                    <input type="text" style={styles.input} name="pause_start" className="required"
                                      value={this.state.pause_start} onChange={this.handleChange}/>
                                  </div>
                                  <div style={styles.items} className="col-md-12">
                                    <span style={{color:'red',fontSize:'80%',paddingLeft:'1%'}}>Leave Blank if start from current day </span>
                                  </div>
                                  <div style={styles.items} className="col-md-12">
                                    <div style={styles.item_header} className="col-md-6">
                                      Date till you want to Pause (DD/MM/YYYY)
                                    </div>
                                    <input type="text" style={styles.input} name="pause_date" className="required"
                                      value={this.state.pause_date} onChange={this.handleChange}/>
                                  </div>
                                </div>
                              </Dialog>
                            }
                            </div>
                            </div>
                            :
                            <button style={{backgroundColor: '#FDD60B', borderColor: '#FDD60B',borderRadius: '4px', borderWidth: '0px',marginTop: '3px',padding:'6px'}}
                            type="button" onClick={()=>alert("Can't Pause Subscription")}>Pause Subscription</button>

                          } 


                          </div>
                            {this.state.dialog_unpause_open == true?
                            <Dialog
                                  actions={unpause_actions}
                                  modal={false}
                                  open={this.state.dialog_unpause_open}
                                  onRequestClose={this.handleClose}
                                  style ={{zIndex:'10000000'}}

                                >
                                  <div>
                                    
                                    <div style={styles.items} className="col-md-12">
                                      <div style={styles.item_header} className="col-md-6">
                                        Rejoining date (YYYY/MM/DD)
                                      </div>
                                      <input type="text" style={styles.input} name="rejoining_date" className="required"
                                        value={this.state.rejoining_date} onChange={this.handleChange}/>
                                    </div>
                                    
                                  </div>
                                </Dialog>
                                :
                                ''


                            }
                        </div>
                      </div>
                      ))
                  }
                </div>
                
            </div>
            :
            (this.state.active_tab == 4) ?
            <div style={{flexDirection: 'column', backgroundColor: '#fff', padding: '1%', display: 'flex',height:'auto'}}>
                  {

                    this.state.support_tickets.map((support, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row',display:'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{support.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000', fontWeight: '600'}}>{support.status_display}</span>
                        </div>
                         <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',fontWeight: '600'}}>{support.comment}</span>
                        </div>
                        <div className="col-md-4" style={{ justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600', }}>{support.content}</span>
                        </div>

                        <div className="col-md-2" style={{justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{support.ticket_type_display}</span>
                        </div>
                      </div>
                      ))
                  }
            </div>
            :
            (this.state.active_tab == 5) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', padding: '1%', display: 'flex'}}>
                <div>
                  {

                    this.state.session_feedbacks.map((session, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row', display:'flex', marginBottom: '1%', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000',fontWeight: '600'}}>{session.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000', fontWeight: '600'}}>{session.rating}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',fontWeight: '600'}}>{session.comment}</span>
                        </div>
                        <div className="col-md-4" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600', }}>{session.admin_comment}</span>
                        </div>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{session.status}</span>
                        </div>
                      </div>
                      ))
                  }
                </div>
            </div>
            :
            (this.state.active_tab == 6) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              { this.state.result.bookings.length > 0 ?
                <div>
                  {
                    this.state.result.bookings.map((attendance, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'row', marginBottom: '1%',display: 'flex', height: 'auto', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{attendance.status}</span>
                        </div>
                         <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontWeight: '600'}}>{this.state.result.attendance_percentage}</span>
                        </div>
                        
                         
                      </div>
                      ))
                  }
                </div>
                :
                ""
              }
            </div>
            :
            (this.state.active_tab == 7) ?
            <div className="col-md-12" style={{flexDirection: 'column', backgroundColor: '#fff', marginLeft: '3px', padding: '1%', display: 'flex'}}>
              {this.state.activities.length > 0 ?
                <div>
                  {

                    this.state.activities.map((activity, index)=>(
                      <div key={index} style={{backgroundColor: '#f2f2f2', flexDirection: 'column', marginBottom: '1%', height: '80px', padding: '1%'}}>

                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{activity.created_on}</span>
                        </div>
                        
                        <div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px', flexWrap: 'wrap',}}>
                          <span style={{color: '#000', fontSize: '15px', fontWeight: '600'}}>{activity.updated_on}</span>
                        </div>

                        {/*<div className="col-md-2" style={{flexDirection: 'row', justifyContent: 'space-between', marginTop: '2px'}}>   
                            <span style={{color: '#000',  fontSize: '15px', fontWeight: '600'}}>{activity.path}</span>
                        </div>*/}
                         
                        
                      </div>
                      ))
                  }
                  </div>
                  :
                  ""
                }
                
            </div>
            :
            <div style={{height:500}}>
                    <div style={{  position: 'absolute',top: '50%',left: '50%',width: '100%',height: '100%'}}><CircularProgress /></div>
                  </div>
                }

          </div>
          </div>

          </div>
          :
         <div className="loading-overlay"><Spinner name="ball-grid-pulse" color="darkturquoise"/></div>


      }
          { this.state.popUpVisible ?
            <div >

             <Modal
                isOpen={this.state.popUpVisible}
                onRequestClose={this.closeModal}
                style={customStyles}

              >
                <button className ="btn" onClick={this.closeModal} style={{color:'red',position:'absolute',right:-15,top:-5}}><i className="fa fa-close fa-2x" ></i></button>
                  {(this.state.name== 'EditLead')?
                    <EditLead match={{"params":{"id":this.state.id}}}/>
                  : 
                  ((this.state.name == 'ScheduleDemo')?
                  <ScheduleDemo match={{"params":{"id":this.state.id}}}/>
                  :
                  (this.state.name == 'EditProfile') ?
                  <EditProfile match={{"params":{"id":this.state.id}}}/>
                  :
                  <ChildProfile match={{"params":{"id":this.state.id}}}/>
                  )
                  
                }
                
              </Modal>
            </div>
            :
            ""
          }
      </div>
    );
  }
}

export default CustomerDetails;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/customerDetails/index.js